import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";
import EmptyState from "../../Components/EmptyState";

export default function Faq() {
  const { showPage, setShowPage, accessObject } = useAppContext();
  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState([]);
  const [rowValue, setRowValue] = React.useState();
  const [openValue, setOpenValue] = React.useState(0);
  const [loader, setLoader] = React.useState(false);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [buttonLoader, setbuttonLoader] = React.useState(false);
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const LoginSchema = Yup.object().shape({
    title: Yup.string().required("required"),
    subtitle: Yup.string().required("required"),
  });

  React.useEffect(() => {
    getBranch();
  }, []);

  const getBranch = () => {
    setLoader(true);
    axios(`${API_URL}/api/admin/faq/get-faq`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        setLoader(false);
        console.log("dataTable.dataRows :::", response.data.data);
        setTableData(response.data.data);
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
      });
  };

  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const clickEditButton = (item) => {
    setShowPage(true);
    setRowValue(item);
    setOpenValue(2);
  };

  const openAddTournament = (value) => {
    setRowValue();
    console.log("openAddTournament :::", value);
    setShowPage(true);
    setOpenValue(value);
  };

  const updateTournament = (value) => {
    console.log("updateTournament value :::", value);

    axios
      .patch(`${API_URL}/api/admin/faq/update-faq/${rowValue._id}`, value)
      .then((res) => {
        console.log("updateTournament update :::", res.data);
        if (res.data.status) {
          successEdit(res.data.message);
          setbuttonLoader(false);
        } else {
          warningAlert();
          setbuttonLoader(false);
        }
      })
      .catch((err) => {
        setbuttonLoader(false);
        console.log("updateTournament err :::", err);
        warningAlert();
      });
  };

  const addNewTournament = (value) => {
    console.log("addNewTournament ---", value);

    axios(`${API_URL}/api/admin/faq/add-faq`, {
      method: "POST",
      credentials: "include",
      data: value,
    })
      .then((result) => {
        console.log("addNewTournament result :::", result.data);
        if (result.data.status) {
          setbuttonLoader(false);
          successAdd();
        } else {
          warningAlert();
          setbuttonLoader(false);
        }
      })
      .catch((err) => {
        console.log("addNewTournament err :::", err);
        warningAlert();
      });
  };

  const warningWithConfirmMessage = (e) => {
    setAlert(
      <SweetAlert
        custom
        showCancel
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        onConfirm={() => {
          successDeleted();
          deleteData(e);
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm bg-danger shadow-danger"
        cancelBtnClass="premium-alert-cancel"
        customIcon={<div className="mb-4" style={{ fontSize: '50px', color: '#dc3545' }}><i className="fas fa-trash-alt"></i></div>}
      >
        <div className="premium-alert-title">Are you sure?</div>
        <p className="premium-alert-text">You are about to delete this FAQ record. This action cannot be undone.</p>
      </SweetAlert>
    );
  };

  const successDeleted = () => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Deleted!</div>
        <p className="premium-alert-text">The FAQ record has been successfully removed.</p>
      </SweetAlert>
    );
  };

  const deleteData = (e) => {
    console.log("e===>", e._id);
    axios.delete(`${API_URL}/api/admin/faq/delete-faq/${e._id}`).then((res) => {
      getBranch();
    });
  };

  const successAdd = () => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Success!</div>
        <p className="premium-alert-text">The FAQ record has been added successfully.</p>
      </SweetAlert>
    );
  };

  const successEdit = () => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Success!</div>
        <p className="premium-alert-text">The FAQ record has been updated successfully.</p>
      </SweetAlert>
    );
  };

  const warningAlert = () => {
    setAlert(
      <SweetAlert
        warning
        onConfirm={() => setAlert(null)}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Wait!</div>
        <p className="premium-alert-text">Something went wrong. Please try again later.</p>
      </SweetAlert>
    );
  };

  return (
    <>
      {alert}
      {showPage ? (
        <div class="content p-3 ">
          <div className="card p-3">
            <Box sx={{ width: "100%" }}>
              <Formik
                initialValues={{
                  title: rowValue ? rowValue.title : "",
                  subtitle: rowValue ? rowValue.subtitle : "",
                  qandA: rowValue
                    ? rowValue.qandA
                    : [
                      {
                        question: "",
                        answer: "",
                      },
                    ],
                }}
                validationSchema={LoginSchema}
                onSubmit={(values) => {
                  setbuttonLoader(true);
                  console.log("values...", values);

                  if (openValue === 1) {
                    console.log("update formik value :::", openValue);
                    addNewTournament(values);
                  }
                  if (openValue === 2) {
                    console.log("update formik value :::", openValue);
                    updateTournament(values);
                  }
                }}
              >
                {({ touched, errors, values }) => (
                  <Form>
                    <div className="row">
                      {/* Title & Subtitle */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>FAQ Title <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="title"
                            placeholder="e.g. Account Help"
                            className={`mt-1 form-control ${touched.title && errors.title ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="title" className="invalid-feedback" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Sub Title <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="subtitle"
                            placeholder="Short description"
                            className={`mt-1 form-control ${touched.subtitle && errors.subtitle ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="subtitle" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <hr className="my-4" />

                    {/* qandA Section */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="mb-0">Questions & Answers</h5>
                      <FieldArray
                        name="qandA"
                        render={(arrayHelpers) => (
                          <button
                            className="btn btn-outline-primary btn-sm"
                            type="button"
                            onClick={() => arrayHelpers.unshift({ question: "", answer: "" })}
                          >
                            <AddIcon fontSize="small" className="mr-1" /> Add New Q&A
                          </button>
                        )}
                      />
                    </div>

                    <FieldArray
                      name="qandA"
                      render={(arrayHelpers) => (
                        <div>
                          {values.qandA.map((_, index) => (
                            <div key={index} className="card mb-3 shadow-sm border-0 bg-light" style={{ borderRadius: '10px' }}>
                              <div className="card-body p-3">
                                <div className="row align-items-start">
                                  <div className="col-md-1 text-center pt-2">
                                    <span className="badge badge-secondary">{index + 1}</span>
                                  </div>
                                  <div className="col-md-10">
                                    <div className="form-group mb-2">
                                      <Field
                                        type="text"
                                        name={`qandA[${index}].question`}
                                        placeholder="Question"
                                        className="form-control"
                                      />
                                    </div>
                                    <div className="form-group mb-0">
                                      <Field
                                        as="textarea"
                                        name={`qandA[${index}].answer`}
                                        placeholder="Answer"
                                        rows={2}
                                        className="form-control"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-1 text-right">
                                    <button
                                      className="btn btn-link text-danger p-0 mt-2"
                                      type="button"
                                      disabled={values.qandA.length === 1}
                                      onClick={() => arrayHelpers.remove(index)}
                                    >
                                      <ClearIcon />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    />

                    <div className="d-flex mt-4 pt-4 border-top">
                      <button
                        style={{ width: "110px" }}
                        type="submit"
                        className="btn btn-primary mr-2"
                        disabled={buttonLoader}
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          <b>Submit</b>
                          {buttonLoader && (
                            <div className="spinner-border ml-2" role="status" style={{ height: "16px", width: "16px" }} />
                          )}
                        </div>
                      </button>
                      <button
                        style={{ width: "110px" }}
                        onClick={() => setShowPage(false)}
                        type="button"
                        className="btn btn-secondary ms-2"
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Box>
          </div>
        </div>
      ) : (
        <div className="content p-3">
          <div className="card">
            <div className="card-header bg-white border-bottom-0 pb-0 pt-4 px-4">
              <div className="row align-items-end">
                <div className="col-md-6 mb-3 mb-md-0">
                  {/* Empty space to align Add button to the right */}
                </div>
                <div className="col-md-6 text-right">
                  {accessObject?.editGameHandle === true && (
                    <button
                      onClick={() => {
                        openAddTournament(1);
                      }}
                      type="button"
                      className="btn btn-primary"
                    >
                      <AddIcon /> Add New
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div class="card-body" style={{ overflow: "scroll" }}>
              <table id="" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>SrNo</th>
                    <th>Title</th>
                    <th>Sub Title</th>
                    {(accessObject?.editGameHandle === true ||
                      accessObject?.deleteGameHandle === true) && (
                        <th style={{ textAlign: "center" }}>Action</th>
                      )}
                  </tr>
                </thead>
                <tbody>
                  {!loader ? (
                    <>
                      {tableData.length > 0 ? (
                        <>
                          {tableData
                            ?.slice(pagination.start, pagination.end)
                            .map((item, index) => (
                              <>
                                <tr key={index}>
                                  <td>{index + 1 + pagination.start}</td>
                                  <td>{item.title}</td>
                                  <td>{item.subtitle}</td>
                                  {(accessObject?.editGameHandle === true ||
                                    accessObject?.deleteGameHandle ===
                                    true) && (
                                      <td className="justify-content-evenly ">
                                        <div className="d-flex">
                                          {accessObject?.editGameHandle ===
                                            true && (
                                              <EditIcon
                                                className="mr-3 courser"
                                                onClick={() =>
                                                  clickEditButton(item)
                                                }
                                              />
                                            )}
                                          {accessObject?.deleteGameHandle ===
                                            true && (
                                              <ClearIcon
                                                className="courser text-danger"
                                                onClick={() =>
                                                  warningWithConfirmMessage(item)
                                                }
                                              />
                                            )}
                                        </div>
                                      </td>
                                    )}
                                </tr>
                              </>
                            ))}
                        </>
                      ) : (
                        <EmptyState colSpan={5} />
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </tbody>
              </table>
              <div className="mt-4">{loader && <Loader />}</div>
            </div>
            {tableData.length !== 0 && (
              <Pagination
                updateShowPerpagevalue={updateShowPerpagevalue}
                showPrePage={showPrePage}
                onPaginationChange={onPaginationChange}
                total={tableData.length}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}
